import { BreakpointKey } from '../utils/useBreakpointTokens';
import { useBreakpointContext } from './useBreakpointContext';

export function useMatchedBreakpoints(): BreakpointKey[] | ['base'] {
  const context = useBreakpointContext();
  return context?.matchedBreakpoints ?? ['base'];
}
